// see http://vuejs-templates.github.io/webpack for documentation.
var path = require('path');

module.exports = {
  build: {
    env: require('./prod.env'),//指定构建环境，可以根据需要设置不同的环境变量、API 地址等。
    index: path.resolve(__dirname, '../dist/index.html'),//指定构建环境，可以根据需要设置不同的环境变量、API 地址等。
    assetsRoot: path.resolve(__dirname, '../dist'),//指定构建后的静态文件的根目录路径。
    assetsSubDirectory: 'static',//指定构建后的静态文件的根目录路径。
    assetsPublicPath: '/',  // 编译发布的根目录，可配置为资源服务器域名或 CDN 域名
    productionSourceMap: true,//指定是否生成生产环境的源映射文件。
    productionGzip: false,//指定是否启用 gzip 压缩。
    productionGzipExtensions: ['js', 'css'],//指定需要进行 gzip 压缩的文件扩展名。
    bundleAnalyzerReport: process.env.npm_config_report,// 指定是否生成构建报告，可以通过命令行参数来控制。
    //baseUrl: 'https://42.123.90.98:8080'
    baseUrl: 'https://wakooedu.cn'// 指定是否生成构建报告，可以通过命令行参数来控制。
    //baseUrl:'https://localhost'
  },
  dev: {
    env: require('./dev.env'),// 指定构建环境，可以根据需要设置不同的环境变量、API 地址等。
    port: 80,//指定开发服务器的端口号
    // port:8080,
    autoOpenBrowser: true,//是否在构建完成后自动打开浏览器
    assetsSubDirectory: 'static',//指定开发环境下静态资源的输出子目录。
    assetsPublicPath: '/',//指定开发环境下静态资源的引用路径。
    proxyTable: {//指定开发环境下静态资源的引用路径。
      //  少帅 本地  代理配置
      // '/repositories/yii2-starter-kit/frontend/web/wedu/v1': {
      //   target: 'http://192.168.5.108',
      //   changeOrigin: true
      // },
      // 测试服务器代理配置
      '/api': {
        target: 'http://192.168.0.114',
        changeOrigin: true,
        pathRewrite: {
          '^/api': ''
        }
      }
    },
    // CSS Sourcemaps off by default because relative paths are "buggy"
    // with this option, according to the CSS-Loader README
    // (https://github.com/webpack/css-loader#sourcemaps)
    // In our experience, they generally work as expected,
    // just be aware of this issue when enabling this option.
    cssSourceMap: false, //是否生成 CSS 的源映射文件
    // baseUrl: 'http://localhost'
    baseUrl: 'http://192.168.0.114' //指定 API 的基础 URL 地址。
  }
};



//////////////////
// WEBPACK FOOTER
// ./config/index.js
// module id = 164
// module chunks = 1